export function ChevronDownIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" {...props}>
      <path d="M16.06,7.31a1,1,0,0,0-1.44,0L10,11.93,5.38,7.31a1,1,0,0,0-1.44,0,1,1,0,0,0,0,1.44l5.34,5.34a1,1,0,0,0,1.44,0l5.34-5.34A1,1,0,0,0,16.06,7.31Z" />
    </svg>
  )
}
